/* eslint-disable no-async-promise-executor */
/*
 * @Description: 进入结算中心相关内容优先判断是否开通账户，未开、开通中则不可直接进入
 * @Date: 2021-05-14 16:18:51
 */
import store from '@/store';

import { dictionaries } from '@/api/ajax';

const asideName = 'settlementCenterList';

// 获取企业开户状态
export const getAuthStatus = async () => {
  const {
    pdata: { zbAuthStatus, fyAuthStatus, offlineProject, payType }
  } = await dictionaries.isOpenAccount();
  return {
    zbAuthStatus, // authStatus 平台审核状态  0  初始化  1 平台审核中 2平台审核失败  3  平台审核通过  4银行审核中 5银行审核失败  6 银行通过
    fyAuthStatus,
    offlineProject, // offlineProject 1线上 2线下(可进入未开通页面) 3线上+线下，该字段代表企业是否有线上、线下的项目
    payType, // payType 1线上 2线下,该字段表示企业是线上的还是线下的
    showOpenFlag: +zbAuthStatus === 6 || +fyAuthStatus === 6 || payType === 2 // true,则表示已开通账户（线上或线下），线下未开通账户(开通中、开通失败)一样可以进行正常操作。false 表示线上未开通账户。
  };
};
/**
 * @description: 检查当前路由是否需要去开户以及后续跳转
 * @param {object} currentRoute 当前路由
 * @return {promise} 根据当前计算返回跳转地址
 */
// export const checkCurrentRoute = async currentRoute => {
//   // 只处理结算中心
//   if (currentRoute.meta.asideName === asideName) {
//     const { showOpenFlag } = await getAuthStatus();
//     // 已开通
//     if (showOpenFlag) {
//       store.commit('SET_SHOW_MENUS', true);
//       return Promise.resolve(true);
//     } else {
//       // 未开通
//       store.commit('SET_SHOW_MENUS', false);
//       // 处于概要页路由正常执行
//       if (currentRoute.name === 'account') {
//         return Promise.resolve(true);
//       }
//       // 重定向到概要页
//       return Promise.reject({ name: 'account' });
//     }
//   } else {
//     store.commit('SET_SHOW_MENUS', true); // 其他页面该值置为默认true
//     return Promise.resolve(true);
//   }
// };
